import { alpha, Theme } from '@mui/material';
import { useBlendColors } from 'hooks/useDesign';

export default {
    hierarchyPanelBox: {
        height: 1,
        //overflow: 'hidden',
        flexShrink: 0,
        position: 'relative',

        '&.dashboard__hierarchy-container--collapsed-compact': {
            width: '41px',
        },

        '.hierarchy--view-compact.hierarchy-collapsed': {
            position: 'absolute',
            zIndex: 1,
            '&:hover, body.catalog-tile-dragging &, body.hierarchy-section-active-menu &, body.navbar-menu--state-opened &':
                {
                    boxShadow: (theme: Theme) => `0px 8px 16px 0px ${alpha(theme.palette.text.primary, 0.24)}`,
                },
        },
        //collapsed state
        'body:not(.catalog-tile-dragging):not(.hierarchy-section-active-menu):not(.navbar-menu--state-opened) &:not(:hover) .hierarchy--view-compact.hierarchy-collapsed':
            {
                '.hierarchy__pinned-items': {
                    display: 'none',
                },
                '.common-items .common-item__label': {
                    display: 'none',
                },
                '.hierarchy-section .hierarchy-section__label, .hierarchy-section .hierarchy-section__items': {
                    display: 'none',
                },
                '.hierarchy-section__heading--active-child': {
                    backgroundColor: (theme: Theme) =>
                        useBlendColors(
                            alpha(theme.componentSettings.leftbar.collapsedTextColor, 0.08),
                            theme.componentSettings.leftbar.collapsedBackgroundColor,
                        ),
                },
                '.hierarchy-section .section-action-menu-holder': {
                    display: 'none',
                },
                '.hierarchy-resize-container': {
                    minWidth: '0 !important',
                    width: '41px !important',
                    borderColor: (theme: Theme) =>
                        useBlendColors(
                            alpha(theme.componentSettings.leftbar.collapsedTextColor, 0.08),
                            theme.componentSettings.leftbar.collapsedBackgroundColor,
                        ),
                    backgroundColor: (theme: Theme) => theme.componentSettings.leftbar.collapsedBackgroundColor,
                    color: (theme: Theme) => theme.componentSettings.leftbar.collapsedTextColor,
                },
                '.hierarchy-section': {
                    borderColor: (theme: Theme) =>
                        useBlendColors(
                            alpha(theme.componentSettings.leftbar.collapsedTextColor, 0.08),
                            theme.componentSettings.leftbar.collapsedBackgroundColor,
                        ),
                },
                '.common-item': {
                    '&.active': {
                        fontWeight: (theme: Theme) => {
                            if (
                                ['600', 'semibold'].includes(
                                    (theme.typography.catalogMenu.fontWeight ?? '').toString().toLowerCase(),
                                )
                            ) {
                                return 900;
                            }
                            return 600;
                        },
                        backgroundColor: (theme: Theme) =>
                            useBlendColors(
                                alpha(theme.componentSettings.leftbar.collapsedTextColor, 0.08),
                                theme.componentSettings.leftbar.collapsedBackgroundColor,
                            ),
                    },
                },
            },
    },
    hierarchyPanelWrapper: {
        height: 1,
        //overflow: 'hidden', //left menu crop
        position: 'relative',
        '.hierarchy-resize-container': {
            display: 'flex',
            flexDirection: 'column',
            height: 1,
            //overflow: 'hidden', //left menu crop
            borderRight: '1px solid',
            borderColor: (theme: Theme) =>
                useBlendColors(
                    alpha(theme.componentSettings.leftbar.expandedTextColor, 0.08),
                    theme.componentSettings.leftbar.expandedBackgroundColor,
                ),
            backgroundColor: (theme: Theme) => theme.componentSettings.leftbar.expandedBackgroundColor,
            color: (theme: Theme) => theme.componentSettings.leftbar.expandedTextColor,
        },
    },
    hierarchyPanelPinned: {
        flexShrink: 0,
        pl: 3,
        pr: 1.5,
    },
    hierarchyPinnedItem: {
        padding: '5px 10px',
    },
    commonItemLink: {
        fontFamily: (theme: Theme) => theme.typography.catalogMenu.fontFamily as string,
        fontWeight: (theme: Theme) => theme.typography.catalogMenu.fontWeight as string,
        textTransform: (theme: Theme) => theme.typography.catalogMenu.textTransform as string,
        fontStyle: (theme: Theme) => theme.typography.catalogMenu.fontStyle as string,
        fontSize: (theme: Theme) => theme.typography.catalogMenu.fontSize as number,
        display: 'flex',
        flexWrap: 'wrap',
        borderRadius: '3px',
        '& .svg-icon-mi': {
            flexShrink: 0,
        },
        '&.active': {
            fontWeight: (theme: Theme) => {
                if (
                    ['600', 'semibold'].includes(
                        (theme.typography.catalogMenu.fontWeight ?? '').toString().toLowerCase(),
                    )
                ) {
                    return 900;
                }
                return 600;
            },
            backgroundColor: (theme: Theme) =>
                useBlendColors(
                    alpha(theme.componentSettings.leftbar.expandedTextColor, 0.08),
                    theme.componentSettings.leftbar.expandedBackgroundColor,
                ),
        },
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: (theme: Theme) =>
                useBlendColors(
                    alpha(theme.componentSettings.leftbar.expandedTextColor, 0.04),
                    theme.componentSettings.leftbar.expandedBackgroundColor,
                ),
        },
    },
    commonItemLinkIcon: {
        display: 'flex',
        width: '32px',
        height: '30px',
        justifyContent: 'center',
        alignItems: 'center',
    },
    commonItemLinkLabel: {
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
        pr: 0.5,
    },
    commonItemLinkLabelAlign: {
        lineHeight: '13px',
    },
    hierarchyPanelMain: {
        flexGrow: 1,
        overflow: 'auto',
    },
    hierarchySection: {
        p: 0.5,
        borderTop: '1px solid',
        borderColor: (theme: Theme) =>
            useBlendColors(
                alpha(theme.componentSettings.leftbar.expandedTextColor, 0.08),
                theme.componentSettings.leftbar.expandedBackgroundColor,
            ),
        '&.common-items': {
            borderTop: 0,
        },
    },
    hierarchySectionHeading: {
        position: 'relative',
        display: 'flex',
        '& .svg-icon-mi': {
            flexShrink: 0,
        },
        '&:hover, &.section-action-menu-active': {
            cursor: 'pointer',
            backgroundColor: (theme: Theme) =>
                useBlendColors(
                    alpha(theme.componentSettings.leftbar.expandedTextColor, 0.04),
                    theme.componentSettings.leftbar.expandedBackgroundColor,
                ),
        },
        '&:hover .section-action-menu, &.section-action-menu-active .section-action-menu': {
            display: 'inline-flex',
        },
        '&:hover .section-action-menu-holder, &.section-action-menu-active .section-action-menu-holder': {
            backgroundColor: (theme: Theme) =>
                useBlendColors(
                    alpha(theme.componentSettings.leftbar.expandedTextColor, 0.04),
                    theme.componentSettings.leftbar.expandedBackgroundColor,
                ),
            '&:after': {
                backgroundImage: (theme: Theme) =>
                    `linear-gradient(90deg, ${alpha(
                        theme.componentSettings.leftbar.expandedTextColor,
                        0,
                    )} 0%, ${useBlendColors(
                        alpha(theme.componentSettings.leftbar.expandedTextColor, 0.04),
                        theme.componentSettings.leftbar.expandedBackgroundColor,
                    )} 100%)`,
            },
        },
    },
    hierarchySectionHeadingIcon: {
        display: 'flex',
        width: '32px',
        height: '30px',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,
    },
    hierarchySectionHeadingLabel: {
        fontFamily: (theme: Theme) => theme.typography.catalogMenu.fontFamily as string,
        textTransform: (theme: Theme) => theme.typography.catalogMenu.textTransform as string,
        fontStyle: (theme: Theme) => theme.typography.catalogMenu.fontStyle as string,
        fontSize: (theme: Theme) => theme.typography.catalogMenu.fontSize as number,
        fontWeight: (theme: Theme) => {
            if (
                ['600', 'semibold'].includes((theme.typography.catalogMenu.fontWeight ?? '').toString().toLowerCase())
            ) {
                return 900;
            }
            return 600;
        },
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
        pr: 0.5,
    },
    hierarchySectionHeadingLabelAlign: {
        lineHeight: '13px',
    },
    hierarchySectionHeadingActionHolder: {
        display: 'inline-flex',
        position: 'absolute',
        right: '4px',
        top: '3px',
        zIndex: 1,
        backgroundColor: (theme: Theme) => theme.componentSettings.leftbar.expandedBackgroundColor,
        '&:after': {
            content: '""',
            position: 'absolute',
            right: '100%',
            top: 0,
            width: '8px',
            height: 1,
            borderRadius: 1,
            backgroundImage: (theme: Theme) =>
                `linear-gradient(90deg, ${alpha(theme.componentSettings.leftbar.expandedBackgroundColor, 0)} 0%, ${theme.componentSettings.leftbar.expandedBackgroundColor} 100%)`,
        },
    },
    hierarchySectionHeadingActionMenuBtn: {
        display: 'none',
    },
    hierarchySectionHeadingCollapseBtn: {
        p: 0.5,
        borderRadius: '3px',
        color: (theme: Theme) => theme.componentSettings.leftbar.expandedTextColor,
        '&:hover': {
            color: (theme: Theme) => theme.componentSettings.leftbar.expandedTextColor,
            backgroundColor: (theme: Theme) =>
                useBlendColors(
                    alpha(theme.componentSettings.leftbar.expandedTextColor, 0.08),
                    theme.componentSettings.leftbar.expandedBackgroundColor,
                ),
        },
    },
    //hierarchy Action Menu [START]
    hierarchyActionBtn: {
        '.MuiIconButton-root': {
            borderRadius: 1,
            p: 0,
            width: '24px',
            height: '24px',
            '&:hover': {
                backgroundColor: (theme: Theme) =>
                    useBlendColors(
                        alpha(theme.componentSettings.leftbar.expandedTextColor, 0.08),
                        theme.componentSettings.leftbar.expandedBackgroundColor,
                    ),
                cursor: 'pointer',
            },
            '&.active-state': {
                pointerEvents: 'none',
                backgroundColor: 'background.default',
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                boxShadow: '0px 4px 4px 0px rgba(34, 34, 34, 0.16)',
                '.svg-icon-mi': { color: 'primary.main' },
            },
            '.svg-icon-mi': { color: (theme: Theme) => theme.componentSettings.leftbar.expandedTextColor },
        },
    },
    hierarchyActionMenuHolder: {
        zIndex: 1601,
        '.MuiPaper-root': {
            borderTopRightRadius: 0,
            boxShadow: (theme: Theme) => `0px 4px 4px 0px ${alpha(theme.palette.text.primary, 0.16)}`,
        },
    },
    hierarchyActionMenuList: {
        minWidth: '141px',
        maxWidth: '220px',
    },
    hierarchyActionMenuItem: {
        display: 'flex',
        py: '6px',
        px: 1.5,
        '&:hover': {
            backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.04),
            cursor: 'pointer',
        },
    },
    hierarchyActionMenuItemIcon: {
        display: 'flex',
        pt: '2px',
        flexShrink: 0,
        mr: 1,
    },
    hierarchyActionMenuItemLabel: {},
    //hierarchy Action Menu [END]

    hierarchySectionItems: {
        '&.hierarchy-section__items--collapsed': {
            display: 'none',
        },
    },
    hierarchyItem: {
        position: 'relative',
        flexDirection: 'row',
        borderRadius: '3px',
        '&:hover, &.item-action-menu-active': {
            backgroundColor: (theme: Theme) =>
                useBlendColors(
                    alpha(theme.componentSettings.leftbar.expandedTextColor, 0.04),
                    theme.componentSettings.leftbar.expandedBackgroundColor,
                ),
            '.hierarchy-item__child-line': {
                backgroundImage: (theme: Theme) =>
                    `repeating-linear-gradient(to right, ${useBlendColors(
                        alpha(theme.componentSettings.leftbar.expandedTextColor, 0.12),
                        theme.componentSettings.leftbar.expandedBackgroundColor,
                    )}, ${useBlendColors(
                        alpha(theme.componentSettings.leftbar.expandedTextColor, 0.12),
                        theme.componentSettings.leftbar.expandedBackgroundColor,
                    )} 1px, transparent 1px, transparent)`,
            },
        },
        '&.active': {
            '& .hierarchy-item__label': {
                fontWeight: (theme: Theme) => {
                    if (
                        ['600', 'semibold'].includes(
                            (theme.typography.catalogMenu.fontWeight ?? '').toString().toLowerCase(),
                        )
                    ) {
                        return 900;
                    }
                    return 600;
                },
            },
            '&:not(:hover)': {
                backgroundColor: (theme: Theme) =>
                    useBlendColors(
                        alpha(theme.componentSettings.leftbar.expandedTextColor, 0.08),
                        theme.componentSettings.leftbar.expandedBackgroundColor,
                    ),
                '.hierarchy-item__child-line': {
                    backgroundImage: (theme: Theme) =>
                        `repeating-linear-gradient(to right, ${useBlendColors(
                            alpha(theme.componentSettings.leftbar.expandedTextColor, 0.12),
                            theme.componentSettings.leftbar.expandedBackgroundColor,
                        )}, ${useBlendColors(
                            alpha(theme.componentSettings.leftbar.expandedTextColor, 0.12),
                            theme.componentSettings.leftbar.expandedBackgroundColor,
                        )} 1px, transparent 1px, transparent)`,
                },
            },
            '.hierarchy-item__expand-icon': {
                //color: 'primary.main',
            },
        },
        '&.drag-over  .hierarchy-item__label': {
            outline: (theme: Theme) => `1px dashed ${theme.palette.primary.main}`,
            zIndex: 1,
            color: 'primary.main',
            backgroundColor: 'transparent',
        },
        '&:not(.drag-over):hover .item-action-menu, &.item-action-menu-active .item-action-menu': {
            display: 'inline-flex',
        },
    },
    hierarchyItemChildLine: {
        flexShrink: 0,
        backgroundSize: '24px 24px',
        backgroundImage: (theme: Theme) =>
            `repeating-linear-gradient(to right, ${useBlendColors(
                alpha(theme.componentSettings.leftbar.expandedTextColor, 0.08),
                theme.componentSettings.leftbar.expandedBackgroundColor,
            )}, ${useBlendColors(
                alpha(theme.componentSettings.leftbar.expandedTextColor, 0.08),
                theme.componentSettings.leftbar.expandedBackgroundColor,
            )} 1px, transparent 1px, transparent)`,
        backgroundPositionX: '15px',
    },
    hierarchyItemExpandIcon: {
        width: '32px',
        height: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        color: (theme: Theme) =>
            useBlendColors(
                alpha(theme.componentSettings.leftbar.expandedTextColor, 0.64),
                theme.componentSettings.leftbar.expandedBackgroundColor,
            ),
    },
    hierarchyItemExpandIconHolder: {
        width: '24px',
        height: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 1,
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: (theme: Theme) => alpha(theme.componentSettings.leftbar.expandedTextColor, 0.08),
        },
        '.hierarchyItem:not(.active) &:hover': {
            color: (theme: Theme) => theme.componentSettings.leftbar.expandedTextColor,
        },
    },
    hierarchyItemLabel: {
        fontFamily: (theme: Theme) => theme.typography.catalogMenu.fontFamily as string,
        textTransform: (theme: Theme) => theme.typography.catalogMenu.textTransform as string,
        fontStyle: (theme: Theme) => theme.typography.catalogMenu.fontStyle as string,
        fontSize: (theme: Theme) => theme.typography.catalogMenu.fontSize as number,
        fontWeight: (theme: Theme) => theme.typography.catalogMenu.fontWeight as string,
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
        pr: 0.5,
        py: '3px',
        overflow: 'hidden',
        '&:hover': {
            cursor: 'pointer',
        },
    },
    hierarchyItemLabelAlign: {
        overflow: 'hidden',
        wordWrap: 'break-word',
        lineHeight: 1.15,
        width: '100%',
    },
    hierarchyItemActionMenuBtn: {
        '.MuiIconButton-root': {
            borderRadius: 1,
            p: 0,
            width: '24px',
            height: '24px',
            backgroundColor: (theme: Theme) =>
                useBlendColors(
                    alpha(theme.componentSettings.leftbar.expandedTextColor, 0.04),
                    theme.componentSettings.leftbar.expandedBackgroundColor,
                ),
            '&:hover': {
                backgroundColor: (theme: Theme) =>
                    useBlendColors(
                        alpha(theme.componentSettings.leftbar.expandedTextColor, 0.08),
                        theme.componentSettings.leftbar.expandedBackgroundColor,
                    ),
                cursor: 'pointer',
            },
            '&.active-state': {
                pointerEvents: 'none',
                backgroundColor: 'background.default',
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                boxShadow: '0px 4px 4px 0px rgba(34, 34, 34, 0.16)',
                '.svg-icon-mi': { color: 'primary.main' },
            },
            '.svg-icon-mi': { color: (theme: Theme) => theme.componentSettings.leftbar.expandedTextColor },
        },
        display: 'none',
        zIndex: 1,
        position: 'absolute',
        right: '4px',
        top: '3px',
        '&:after': {
            content: '""',
            position: 'absolute',
            right: '100%',
            top: 0,
            width: '8px',
            height: 1,
            borderRadius: 1,
            backgroundImage: (theme: Theme) =>
                `linear-gradient(90deg, ${alpha(
                    useBlendColors(
                        alpha(theme.componentSettings.leftbar.expandedTextColor, 0.04),
                        theme.componentSettings.leftbar.expandedBackgroundColor,
                    ),
                    0,
                )} 0%, ${useBlendColors(
                    alpha(theme.componentSettings.leftbar.expandedTextColor, 0.04),
                    theme.componentSettings.leftbar.expandedBackgroundColor,
                )} 100%)`,
        },
    },

    folderTrash: {
        position: 'absolute',
        bottom: '8px',
        left: '12px',
        right: '12px',
        height: '120px',
        border: '1px dashed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        backgroundColor: (theme: Theme) =>
            useBlendColors(
                alpha(theme.componentSettings.leftbar.expandedTextColor, 0.08),
                theme.componentSettings.leftbar.expandedBackgroundColor,
            ),
        lineHeight: 1.1,
        borderRadius: '3px',
        zIndex: 1,
        '&.drag-over': {
            borderColor: 'primary.main',
            backgroundColor: (theme: Theme) => theme.palette.background.default,
            color: 'primary.main',
        },
    },
    folderTrashIcon: {
        color: (theme: Theme) =>
            useBlendColors(
                alpha(theme.componentSettings.leftbar.expandedTextColor, 0.4),
                theme.componentSettings.leftbar.expandedBackgroundColor,
            ),
        mb: 1,
        '.drag-over &': {
            color: 'inherit',
        },
    },
    navbarMenuHolder: {
        fontFamily: (theme: Theme) => theme.typography.catalogMenu.fontFamily as string,
        fontWeight: (theme: Theme) => theme.typography.catalogMenu.fontWeight as string,
        textTransform: (theme: Theme) => theme.typography.catalogMenu.textTransform as string,
        fontStyle: (theme: Theme) => theme.typography.catalogMenu.fontStyle as string,
        fontSize: (theme: Theme) => theme.typography.catalogMenu.fontSize as number,
        padding: 0.5,
        borderTop: '1px solid',
        position: 'relative',
        zIndex: 1,
        borderColor: (theme: Theme) => alpha(theme.componentSettings.leftbar.expandedTextColor, 0.08),

        '.navbar-menu__item-divider': {
            opacity: '0.08 !important',
            backgroundColor: (theme: Theme) => theme.componentSettings.leftbar.expandedTextColor,
        },

        //collapsed state
        'body:not(.catalog-tile-dragging):not(.hierarchy-section-active-menu):not(.navbar-menu--state-opened) .dashboard__hierarchy-container--collapsed-compact:not(:hover) &':
            {
                borderColor: (theme: Theme) => alpha(theme.componentSettings.leftbar.collapsedTextColor, 0.08),
                '.navbar-menu__root-item-label': {
                    display: 'none',
                },
                '.navbar-menu__root-item-icon': {
                    mr: '0',
                },
                '.navbar-menu__item-divider': {
                    backgroundColor: (theme: Theme) => theme.componentSettings.leftbar.collapsedTextColor,
                },
                '.navbar-menu__root-item': {
                    color: (theme: Theme) => theme.componentSettings.leftbar.collapsedTextColor,
                },
                '.navbar-menu__root-item-holder:not(.navbar-menu__root-item-holder--active) .navbar-menu__root-item:hover':
                    {
                        backgroundColor: (theme: Theme) =>
                            alpha(theme.componentSettings.leftbar.collapsedTextColor, 0.04),
                    },
                '.navbar-menu__root-item-holder.navbar-menu__root-item-holder--active .navbar-menu__root-item': {
                    backgroundColor: (theme: Theme) => alpha(theme.componentSettings.leftbar.collapsedTextColor, 0.08),
                },
            },
    },
};
